import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {GRADUATES_ORIENTATION_REQUEST} from "../graduatesOrientationReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GRADUATES_ORIENTATION_REQUEST}${START}`:
            return true;
        case `${GRADUATES_ORIENTATION_REQUEST}${SUCCESS}`:
            return false;
        case `${GRADUATES_ORIENTATION_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};